import { ScaffoldDropZone } from "../../scaffold";
import {
  ARST_ADD_OPERATION_TO_GROUP,
  ARST_INSERT_COLUMN,
  ARST_INSERT_OPERATION_TO_GROUP,
  ARST_INSERT_ROW,
  ARST_INSERT_SUBGROUP,
  ARST_REMOVE_GROUPINGFACTOR,
  ARST_REMOVE_OPERATION,
  ARST_TOGGLE_GROUP_LABEL_VISIBILITY,
  ArsTableCellActionConfig,
  ArsTableCellData,
  ArsTableCellType,
  ArsTableContextMenuActionDefinition,
  ArsTableSidebarItemKind,
  ArsTableState,
} from "./interface";

export const removeGroupingFactor: ArsTableContextMenuActionDefinition = {
  label: "Remove group",
  operation: ARST_REMOVE_GROUPINGFACTOR,
};
export const removeOperation: ArsTableContextMenuActionDefinition = {
  label: "Remove operation",
  operation: ARST_REMOVE_OPERATION,
};
export const toggleGroupFactorLabel: ArsTableContextMenuActionDefinition = {
  label: "Toggle group label",
  operation: ARST_TOGGLE_GROUP_LABEL_VISIBILITY,
};

/**
 * Create action configuration for a given cell
 *
 * @param value - The value of the cell for which the action configuration is being generated
 * @param state - The current state of the ArsTable
 * @returns The action configuration for the given cell
 */
export const cellActionConfig: <T>(
  value: ArsTableCellData<T>,
  state: ArsTableState<T> | null,
) => ArsTableCellActionConfig = (value, state) => {
  if (!state)
    return {
      contextMenuActions: [],
      dropActions: [],
    };

  switch (value.cellType) {
    case ArsTableCellType.ColumnGroupCell:
      return {
        contextMenuActions: [toggleGroupFactorLabel, removeGroupingFactor],
        dropActions: [
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.TopLeft,
              ScaffoldDropZone.LeftEdgeTop,
              ScaffoldDropZone.LeftEdgeBottom,
              ScaffoldDropZone.BottomLeft,
            ],
            operation: ARST_INSERT_COLUMN,
          },
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.TopRight,
              ScaffoldDropZone.RightEdgeTop,
              ScaffoldDropZone.RightEdgeBottom,
              ScaffoldDropZone.BottomRight,
            ],
            operation: ARST_INSERT_COLUMN,
          },
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [ScaffoldDropZone.BottomEdgeLeft, ScaffoldDropZone.BottomEdgeRight],
            operation: ARST_INSERT_SUBGROUP,
          },
        ],
      };
    case ArsTableCellType.RowGroupCell:
      return {
        contextMenuActions: [toggleGroupFactorLabel, removeGroupingFactor],
        dropActions: [
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.TopLeft,
              ScaffoldDropZone.TopEdgeLeft,
              ScaffoldDropZone.TopEdgeRight,
              ScaffoldDropZone.TopRight,
            ],
            operation: ARST_INSERT_ROW,
          },
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.BottomLeft,
              ScaffoldDropZone.BottomEdgeLeft,
              ScaffoldDropZone.BottomEdgeRight,
              ScaffoldDropZone.BottomRight,
            ],
            operation: ARST_INSERT_ROW,
          },
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [ScaffoldDropZone.RightEdgeTop, ScaffoldDropZone.RightEdgeBottom],
            operation: ARST_INSERT_SUBGROUP,
          },
        ],
      };
    case ArsTableCellType.ColumnGroupLabel:
      return {
        contextMenuActions: [toggleGroupFactorLabel],
        dropActions: [
          {
            droppedDataKinds: [
              ArsTableSidebarItemKind.Operation,
              ArsTableSidebarItemKind.AnalysisMethod,
            ],
            dropZones: [
              ScaffoldDropZone.BottomLeft,
              ScaffoldDropZone.BottomEdgeLeft,
              ScaffoldDropZone.BottomEdgeRight,
              ScaffoldDropZone.BottomRight,
            ],
            operation: ARST_ADD_OPERATION_TO_GROUP,
          },
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.TopLeft,
              ScaffoldDropZone.LeftEdgeTop,
              ScaffoldDropZone.LeftEdgeBottom,
            ],
            operation: ARST_INSERT_COLUMN,
          },
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.TopRight,
              ScaffoldDropZone.RightEdgeTop,
              ScaffoldDropZone.RightEdgeBottom,
            ],
            operation: ARST_INSERT_COLUMN,
          },
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.BottomLeft,
              ScaffoldDropZone.BottomEdgeLeft,
              ScaffoldDropZone.BottomEdgeRight,
              ScaffoldDropZone.BottomRight,
            ],
            operation: ARST_INSERT_SUBGROUP,
          },
        ],
      };
    case ArsTableCellType.RowGroupLabel:
      return {
        contextMenuActions: [toggleGroupFactorLabel],
        dropActions: [
          {
            droppedDataKinds: [
              ArsTableSidebarItemKind.Operation,
              ArsTableSidebarItemKind.AnalysisMethod,
            ],
            dropZones: [
              ScaffoldDropZone.TopRight,
              ScaffoldDropZone.RightEdgeTop,
              ScaffoldDropZone.RightEdgeBottom,
              ScaffoldDropZone.BottomRight,
            ],
            operation: ARST_ADD_OPERATION_TO_GROUP,
          },
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.TopLeft,
              ScaffoldDropZone.TopEdgeLeft,
              ScaffoldDropZone.TopEdgeRight,
            ],
            operation: ARST_INSERT_ROW,
          },
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.TopRight,
              ScaffoldDropZone.RightEdgeTop,
              ScaffoldDropZone.RightEdgeBottom,
              ScaffoldDropZone.BottomRight,
            ],
            operation: ARST_INSERT_SUBGROUP,
          },
        ],
      };
    case ArsTableCellType.ColumnOperation:
      return {
        contextMenuActions: [removeOperation],
        dropActions: [
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.TopLeft,
              ScaffoldDropZone.LeftEdgeTop,
              ScaffoldDropZone.LeftEdgeBottom,
              ScaffoldDropZone.BottomLeft,
            ],
            operation: ARST_INSERT_COLUMN,
          },
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.TopRight,
              ScaffoldDropZone.RightEdgeTop,
              ScaffoldDropZone.RightEdgeBottom,
              ScaffoldDropZone.BottomRight,
            ],
            operation: ARST_INSERT_COLUMN,
          },
          {
            droppedDataKinds: [
              ArsTableSidebarItemKind.Operation,
              ArsTableSidebarItemKind.AnalysisMethod,
            ],
            dropZones: [
              ScaffoldDropZone.TopLeft,
              ScaffoldDropZone.LeftEdgeTop,
              ScaffoldDropZone.LeftEdgeBottom,
              ScaffoldDropZone.BottomLeft,
            ],
            operation: ARST_INSERT_OPERATION_TO_GROUP,
          },
          {
            droppedDataKinds: [
              ArsTableSidebarItemKind.Operation,
              ArsTableSidebarItemKind.AnalysisMethod,
            ],
            dropZones: [
              ScaffoldDropZone.TopRight,
              ScaffoldDropZone.RightEdgeTop,
              ScaffoldDropZone.RightEdgeBottom,
              ScaffoldDropZone.BottomRight,
            ],
            operation: ARST_INSERT_OPERATION_TO_GROUP,
          },
        ],
      };
    case ArsTableCellType.RowOperation:
      return {
        contextMenuActions: [removeOperation],
        dropActions: [
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.TopLeft,
              ScaffoldDropZone.TopEdgeLeft,
              ScaffoldDropZone.TopEdgeRight,
              ScaffoldDropZone.TopRight,
            ],
            operation: ARST_INSERT_ROW,
          },
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.BottomLeft,
              ScaffoldDropZone.BottomEdgeLeft,
              ScaffoldDropZone.BottomEdgeRight,
              ScaffoldDropZone.BottomRight,
            ],
            operation: ARST_INSERT_ROW,
          },
          {
            droppedDataKinds: [
              ArsTableSidebarItemKind.Operation,
              ArsTableSidebarItemKind.AnalysisMethod,
            ],
            dropZones: [
              ScaffoldDropZone.TopLeft,
              ScaffoldDropZone.TopEdgeLeft,
              ScaffoldDropZone.TopEdgeRight,
              ScaffoldDropZone.TopRight,
            ],
            operation: ARST_INSERT_OPERATION_TO_GROUP,
          },
          {
            droppedDataKinds: [
              ArsTableSidebarItemKind.Operation,
              ArsTableSidebarItemKind.AnalysisMethod,
            ],
            dropZones: [
              ScaffoldDropZone.BottomLeft,
              ScaffoldDropZone.BottomEdgeLeft,
              ScaffoldDropZone.BottomEdgeRight,
              ScaffoldDropZone.BottomRight,
            ],
            operation: ARST_INSERT_OPERATION_TO_GROUP,
          },
        ],
      };
    case ArsTableCellType.RowHeader:
      return {
        contextMenuActions: [],
        dropActions: [
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.TopRight,
              ScaffoldDropZone.RightEdgeTop,
              ScaffoldDropZone.RightEdgeBottom,
              ScaffoldDropZone.BottomRight,
            ],
            operation: ARST_INSERT_COLUMN,
          },
          {
            droppedDataKinds: [ArsTableSidebarItemKind.GroupingFactor],
            dropZones: [
              ScaffoldDropZone.BottomLeft,
              ScaffoldDropZone.BottomEdgeLeft,
              ScaffoldDropZone.BottomEdgeRight,
            ],
            operation: ARST_INSERT_ROW,
          },
        ],
      };
    default:
      return {
        contextMenuActions: [],
        dropActions: [],
      };
  }
};
